






























































































import { Component, Ref, Vue } from "vue-property-decorator";
import { Carousel } from "bootstrap";
import { Action, Getter, Mutation } from "vuex-class";
import { AlertAction, AlertState, AlertType } from "@/components/alert/types";
import { Namespace } from "@/store/types";
import apiStorageInterface from "@/services/apiStorageInterface";
import {
  MyChannel,
  Promotion,
  UserInfo
} from "@/services/apiService/api.types";
import DateTime from "@/components/overlay/components/centerMenu/DateTime.vue";
import Swiper, {
  Keyboard,
  Navigation,
  Pagination,
  SwiperOptions
} from "swiper";
import SpatialNavigation from "spatial-navigation-js";
import { RouteName } from "@/router/types";
import {
  ChannelChangeAction,
  ChannelChangeMutation
} from "@/components/channelChange/types";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { OverlayAction } from "@/components/overlay/types";
import DateTimeSection from "@/components/DateTimeSection.vue";
import { HomePageGetter, HomePageMutation } from "@/components/homePage/types";
import LockIcon from "@/assets/svg/svg-settings/LockIcon.vue";
import { LocaleHomeString } from "@/plugins/i18n/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import storageService from "@/services/storageService/storageService";
import { defaultUserInfo, LocalStorageItems } from "@/helpers/constants";

require("swiper/swiper-bundle.min.css");
Swiper.use([Navigation, Pagination, Keyboard]);
@Component({
  components: { DateTimeSection, DateTime, LockIcon }
})
export default class Home extends Vue {
  @Ref("bgCarousel") readonly bgCarouselRef!: Element;

  @Action(AlertAction.UpdateAlert, { namespace: Namespace.Alert })
  newAlert!: (ChannelChangeGetter: AlertState) => Promise<void>;

  @Action(ChannelChangeAction.UpdateSource, {
    namespace: Namespace.ChannelChange
  })
  updateSource!: (src: string) => void;

  @Action(ChannelChangeAction.UpdateOffset, {
    namespace: Namespace.ChannelChange
  })
  updateOffset!: (offset: number) => void;

  @Action(OverlayAction.UpdateChannelEpg, {
    namespace: Namespace.Overlay
  })
  updateChannelEpg!: () => Promise<void>;

  @Mutation(ChannelChangeMutation.SetChannelId, {
    namespace: Namespace.ChannelChange
  })
  setChannelId!: (channelId: number) => void;

  @Mutation(HomePageMutation.setPlayedChannelIndex, {
    namespace: Namespace.HomePage
  })
  setPlayedChannelIndex!: (channelIndex?: number) => void;

  @Getter(HomePageGetter.GetPlayedChannelIndex, {
    namespace: Namespace.HomePage
  })
  getPlayedChannelIndex?: number;

  bgCarousel!: Carousel;

  promotions: Promotion[] = [];

  channels: MyChannel[] = [];

  activeSlideIndex = -1;

  smallSwiper = false;

  swiperOptions: SwiperOptions = {
    keyboard: {
      enabled: true
    },
    slidesPerView: 5,
    spaceBetween: 40,
    breakpoints: {
      // when window width is <= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    touchEventsTarget: "wrapper"
  };

  swiperLocal: Swiper | undefined;

  LocaleHomeString = LocaleHomeString;

  userInfo: UserInfo = defaultUserInfo;

  created(): void {
    window.addEventListener("resize", () => {
      this.checkWindowWidth();
    });
    // setting initial status
    this.checkWindowWidth();
  }

  async mounted(): Promise<void> {
    //initialising background carousel
    this.bgCarousel = new Carousel(this.bgCarouselRef, {
      interval: 7000,
      keyboard: false
    });
    this.bgCarousel.cycle();

    this.userInfo = await apiStorageInterface.fetchUserInfo();

    try {
      [this.promotions, this.channels] = await Promise.all<
        Promotion[],
        MyChannel[]
      >([
        apiStorageInterface.fetchPromotions(),
        apiStorageInterface.fetchCustomChannelList()
      ]);

      if (!storageService.hasItem(LocalStorageItems.UserInfo)) {
        await apiStorageInterface.fetchUserInfo();
        storageService.removeItem(LocalStorageItems.SortedCategories);
        await apiStorageInterface.fetchSortedCategories();
        if (this.userInfo.defaultUserLanguage) {
          i18n.locale = this.userInfo.defaultUserLanguage.code;
        }
      }
    } catch (e) {
      const alertInfo: AlertState = {
        show: true,
        message: e.message,
        alertType: AlertType.Danger
      };
      await this.newAlert(alertInfo);
    }

    this.$nextTick(() => {
      this.swiperLocal = new Swiper(".swiper", this.swiperOptions);
      //needed for registering clicks on swiper elements
      this.swiperLocal.on("click", () =>
        this.playChannel(this.swiperLocal?.clickedIndex)
      );

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      this.swiperLocal.on("slideChangeTransitionEnd", () => {
        if (this.getPlayedChannelIndex) {
          this.activeSlideIndex = this.getPlayedChannelIndex;
          SpatialNavigation.pause();
          SpatialNavigation.focus("#id" + this.getPlayedChannelIndex);
          this.setPlayedChannelIndex();
        }
      });

      //making sure no accidental sliding happens
      this.swiperLocal.keyboard?.disable();

      for (let i = 0; i < this.channels.length; i++) {
        this.focusChannel(i);
      }
    });

    //focusing directly on the slider is problematic - maybe said rendering creates issues, @TODO - investigate further
    // SpatialNavigation.focus("#liveHeading");
  }

  async playChannel(channelIndex = -1): Promise<void> {
    if (channelIndex >= 0) {
      this.updateSource(this.channels[channelIndex].videoLive as string);
      this.setChannelId(this.channels[channelIndex].id);
    }
    if (channelIndex < 0) {
      this.updateSource(
        this.channels[this.activeSlideIndex].videoLive as string
      );
      this.setChannelId(this.channels[this.activeSlideIndex].id);
    }
    this.updateOffset(0);
    this.setPlayedChannelIndex(
      channelIndex >= 0 ? channelIndex : this.activeSlideIndex
    );

    await this.updateChannelEpg();
    await this.$router.push({ name: RouteName.Player });
  }

  async handleHomeActions(event: KeyboardEvent): Promise<void> {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_LEFT:
        this.slideLeft();
        break;
      case KeySet.KEY_RIGHT:
        this.slideRight();
        break;
      case KeySet.KEY_ENTER:
        await this.playChannel();
        break;
    }
  }

  //for focusing a specific channel on click or when refocusing played channels
  focusChannel(index: number): void {
    if (
      typeof this.getPlayedChannelIndex !== "undefined" &&
      index === this.channels.length - 1
    ) {
      if (
        this.getPlayedChannelIndex > 2 &&
        this.getPlayedChannelIndex < this.channels.length - 3
      ) {
        this.swiperLocal?.slideTo(this.getPlayedChannelIndex - 2);
      }

      if (this.getPlayedChannelIndex >= this.channels.length - 3) {
        this.swiperLocal?.slideTo(this.channels.length - 5);
      }

      //in case the channel does not require sliding (does not trigger event)
      if (this.getPlayedChannelIndex < 3) {
        SpatialNavigation.focus("#id" + this.getPlayedChannelIndex);
      }
    }
  }

  checkWindowWidth(): void {
    this.smallSwiper = window.innerWidth <= 992;
  }
  slideLeft(): void {
    if (this.activeSlideIndex === 0) {
      this.activeSlideIndex--;
      SpatialNavigation.resume();
      SpatialNavigation.focus(".sidebar .focusable");
      return;
    }

    if (
      (this.activeSlideIndex >= 2 &&
        this.activeSlideIndex <= this.channels.length - 3) ||
      (this.smallSwiper &&
        this.activeSlideIndex >= 1 &&
        this.activeSlideIndex <= this.channels.length - 2)
    ) {
      this.swiperLocal?.slidePrev();
    }

    if (this.activeSlideIndex > 0) this.activeSlideIndex--;
    SpatialNavigation.focus("#id" + this.activeSlideIndex);
  }

  slideRight(): void {
    if (
      (this.activeSlideIndex >= 2 &&
        this.activeSlideIndex <= this.channels.length - 3) ||
      (this.smallSwiper &&
        this.activeSlideIndex >= 1 &&
        this.activeSlideIndex <= this.channels.length - 2)
    ) {
      this.swiperLocal?.slideNext();
    }

    if (this.activeSlideIndex < this.channels.length) this.activeSlideIndex++;
    SpatialNavigation.focus("#id" + this.activeSlideIndex);
  }

  beforeDestroy(): void {
    this.swiperLocal?.off("click");
    window.removeEventListener("resize", this.checkWindowWidth);
  }
}
